import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import ActorCategory from '../../../domain/entities/ActorCategory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexActorCategoriesSuccess: {
      const result = action.payload as PaginatedResult<ActorCategory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
